module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isVisible) ? _c('div', {
    staticClass: "basic-modal"
  }, [_c('div', {
    ref: "container",
    staticClass: "basic-modal__container",
    style: (_vm.modalStyle)
  }, [(_vm.enableCloseButton) ? [_c('div', {
    staticClass: "basic-modal__close-btn",
    on: {
      "click": _vm.clickedExit
    }
  }, [_c('svg-icon', {
    attrs: {
      "icon": _vm.cancel,
      "width": 12,
      "height": 12
    }
  })], 1)] : _vm._e(), _vm._v(" "), _vm._t("default")], 2)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73b19902"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/common/modal/BasicModal.vue
// module id = 1949
// module chunks = 0